var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: "制卡",
            top: "100px",
            width: "680px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "pram", attrs: { "label-width": "150px", model: _vm.pram } },
            [
              _c("el-form-item", { attrs: { label: "订单名称：" } }, [
                _vm._v(_vm._s(_vm.pram.orderName)),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "订单状态：",
                    prop: "status",
                    rules: [
                      {
                        required: true,
                        message: "请选择订单状态",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selWidth mr20",
                      attrs: { placeholder: "请选择", disabled: "" },
                      model: {
                        value: _vm.pram.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "status", $$v)
                        },
                        expression: "pram.status",
                      },
                    },
                    _vm._l(_vm.stateMap, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "制卡方式：",
                    prop: "makeCardType",
                    rules: [
                      {
                        required: true,
                        message: "请选择制卡方式",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.handleMakeCardTypeChange },
                      model: {
                        value: _vm.pram.makeCardType,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "makeCardType", $$v)
                        },
                        expression: "pram.makeCardType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "pre" } }, [
                        _vm._v("预制卡"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "normal" } }, [
                        _vm._v("非预制卡"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.pram.makeCardType === "pre"
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "预制卡批次号：",
                          prop: "preBatchId",
                          rules: [
                            {
                              required: true,
                              message: "请选择预制卡批次号",
                              trigger: ["blur", "change"],
                            },
                          ],
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "selWidth mr20",
                            attrs: {
                              placeholder: "请选择",
                              filterable: "",
                              clearable: "",
                              loading: _vm.preBatchLoading,
                            },
                            on: { change: _vm.handlePreBatchChange },
                            model: {
                              value: _vm.pram.preBatchId,
                              callback: function ($$v) {
                                _vm.$set(_vm.pram, "preBatchId", $$v)
                              },
                              expression: "pram.preBatchId",
                            },
                          },
                          _vm._l(_vm.preBatchOptions, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.batchNo, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.selectedPreBatch
                      ? [
                          _c(
                            "el-form-item",
                            { attrs: { label: "卡面名称：" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.selectedPreBatch.cardFaceName || "--"
                                )
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "可分配数量：" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.preBatchInfoLoading
                                    ? "加载中..."
                                    : _vm.getAvailableCount(
                                        _vm.selectedPreBatch
                                      )
                                )
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "需分配数量：" } },
                            [_vm._v(_vm._s(_vm.pram.quantity))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "剩余可分配卡号段：" } },
                            [
                              _c("div", { staticClass: "range-text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.preBatchInfoLoading
                                      ? "加载中..."
                                      : _vm.getRemainCardNoRange(
                                          _vm.selectedPreBatch
                                        )
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "卡号分配：" } },
                            [
                              _c(
                                "el-table",
                                {
                                  staticClass: "assign-table",
                                  attrs: {
                                    data: _vm.cardNoAssignList,
                                    size: "mini",
                                    border: "",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "卡号段开始",
                                      align: "center",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("el-input", {
                                                attrs: { size: "mini" },
                                                model: {
                                                  value: scope.row.cardNoStart,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "cardNoStart",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.cardNoStart",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3029443888
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "卡号段结束",
                                      align: "center",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("el-input", {
                                                attrs: { size: "mini" },
                                                model: {
                                                  value: scope.row.cardNoEnd,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "cardNoEnd",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.cardNoEnd",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      396739807
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "分配数量",
                                      align: "center",
                                      width: "100",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getAssignCount(
                                                      scope.row
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1499920061
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "操作",
                                      align: "center",
                                      width: "90",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-button",
                                                {
                                                  staticClass: "danger-text",
                                                  attrs: {
                                                    type: "text",
                                                    size: "mini",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.removeAssignRow(
                                                        scope.$index
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("删除")]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4069521939
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "assign-add" },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      type: "text",
                                      icon: "el-icon-circle-plus-outline",
                                    },
                                    on: { click: _vm.addAssignRow },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.debouncedSubmit("pram")
                    },
                  },
                },
                [_vm._v("确认")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }